import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Accordion, Container} from "react-bootstrap";

const faqKeys = ["free", "install", "when", "czech", "dads", "afterBirth", "privacy"];

export const Faq: FC = () => {
	const {t} = useTranslation();

	return (
		<section className="section section--tint" id="faq">
			<Container>
				<div className="section__head">
					<h2 className="section__title">{t("faq.title")}</h2>
					<p className="section__subtitle">{t("faq.subtitle")}</p>
				</div>
				<div className="faq">
					<Accordion flush>
						{faqKeys.map((key, index) => (
							<Accordion.Item key={key} eventKey={String(index)}>
								<Accordion.Header>{t(`faq.items.${key}.question`)}</Accordion.Header>
								<Accordion.Body>{t(`faq.items.${key}.answer`)}</Accordion.Body>
							</Accordion.Item>
						))}
					</Accordion>
				</div>
			</Container>
		</section>
	);
};
